
    import '/Users/lijixiang/Work/power-design/site/docs/power-design/form-list-table.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-form-list-table-demo-form-list-table","docs-power-design-form-list-table-demo-disable-rows","docs-power-design-form-list-table-demo-min-rows"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/form-list-table.md?type=demo')
};